import { Component, OnInit } from '@angular/core';
import { DetectarDispositivoService } from '@services/detectar-dispositivo/detectar-dispositivo.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-descarga-redirect',
  templateUrl: './descarga-redirect.component.html',
  styleUrls: ['./descarga-redirect.component.scss']
})
export class DescargaRedirectComponent implements OnInit {
  readonly URL_IOS = 'https://apps.apple.com/ar/app/signo-medico-osoetsylra/id6747086964';
  readonly URL_ANDROID = 'https://play.google.com/store/apps/details?id=io.cipbyte.signomedico&hl=es_AR';

  isDesktop: boolean = true;

  constructor(
    private dispositivoService: DetectarDispositivoService,
    private router: Router
  ) {}

  ngOnInit() {
    this.redireccionarSegunDispositivo();
  }

  private redireccionarSegunDispositivo(): void {
    if (this.dispositivoService.isAndroid()) {
      this.isDesktop = false;
      window.location.href = this.URL_ANDROID;
    } else if (this.dispositivoService.isIOS()) {
      this.isDesktop = false;
      window.location.href = this.URL_IOS;
    } else {
      // Dispositivo no móvil (Computadora/Escritorio)
      this.isDesktop = true;
    }
  }

  irAHome(): void {
    this.router.navigate(['/home']);
  }
}